module.exports = __webpack_public_path__ + "static/GA-531e0eb5af57eecb83aa5e17696fa7f5.svg";